import React from "react";
import ContentWrapper from "../../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { Button, useAuth } from "../../../components";
import { useNavigate } from "../../../helpers/navigationHelpers";

interface Props {
  onRetry?: () => void;
}

const InviteInvalid: React.FC<Props> = (props): React.ReactElement => {
  const { tInvite, tCommon } = useCustomTranslation();
  const { authenticated, user } = useAuth();

  const navigate = useNavigate();

  return (
    <ContentWrapper largePadding htmlTitle={tInvite("html_title")}>
      <h1>{tInvite("invalid_invite")}</h1>
      <p className="mb-6">{tInvite("invalid_invite_description")}</p>
      <div className="mt-6 flex justify-between sm:w-[480px]">
        {props.onRetry && (
          <Button label={tCommon("retry_button")} onClick={props.onRetry} />
        )}
        <Button
          mode="primary"
          label={
            authenticated && user
              ? tCommon("back_to_app")
              : tCommon("back_to_login_button")
          }
          onClick={() => navigate.goTo("/")}
        />
      </div>
    </ContentWrapper>
  );
};

export default InviteInvalid;
